import React from 'react';

import HiddenDiv from 'components/core/HiddenDiv.component';
import PUSHER from 'config/pusher.singleton';
import { PUSHER_EVENT_CLIENT, PUSHER_EVENT_SMS_CREDITS_AVAILABLE } from 'providers/Pusher.provider';

import { SMS_CREDITS_PUSHER } from 'clientCommunications/constants';
import { CLIENT_PUSHER } from 'lib/constants/currentSalon';

class SalonWatcher extends React.Component {
  UNSAFE_componentWillMount() {
    const channelName = `${this.props.salonId}_channel`;

    PUSHER.redux.subscribe({ channelName, eventName: PUSHER_EVENT_CLIENT, actionType: CLIENT_PUSHER });
    PUSHER.redux.subscribe({
      channelName,
      eventName: PUSHER_EVENT_SMS_CREDITS_AVAILABLE,
      actionType: SMS_CREDITS_PUSHER,
    });
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const channelName = `${nextProps.salonId}_channel`;
    PUSHER.redux.subscribe({ channelName, eventName: PUSHER_EVENT_CLIENT, actionType: CLIENT_PUSHER });
  }

  componentWillUnmount() {
    const channelName = `${this.props.salonId}_channel`;

    PUSHER.redux.unsubscribe({ channelName, eventName: PUSHER_EVENT_CLIENT, actionType: CLIENT_PUSHER });
    PUSHER.redux.unsubscribe({
      channelName,
      eventName: PUSHER_EVENT_SMS_CREDITS_AVAILABLE,
      actionType: SMS_CREDITS_PUSHER,
    });
  }

  render() {
    return <HiddenDiv tag="SalonWatcher--hidden" id="client-watcher" />;
  }
}

export default SalonWatcher;
